import { initGraphQLTada } from 'gql.tada';
import type { CurrencyCode } from '@newfront-insurance/core-money';

import type { introspection } from '../../../infra/typescript-config/graphql-env';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    CalendarDate: string;
    CurrencyCode: CurrencyCode;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';
